import type { FindHyperguestHotelsInput } from '@travel-planner/shared/schemas';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

export const useHyperguestUnconfirmed = (input: FindHyperguestHotelsInput) =>
  trpc.hyperguestHotels.findUnconfirmed.useQuery(input, {
    placeholderData: keepPreviousData,
  });
